<script setup>
// Wspólny komunikat o wyczerpanym limicie AI — pokazuje się nad całą aplikacją przy każdej
// odpowiedzi 429 „ai_limit" (useApi), bo funkcji AI jest wiele i nie każda ma własne miejsce na błąd.
import { aiLimitNotice, hideAiLimitNotice } from '@/composables/useAiLimit.js';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
    <div v-if="aiLimitNotice" role="alert" class="fixed z-[1300] bottom-4 left-1/2 -translate-x-1/2 w-[calc(100%-2rem)] max-w-[460px] rounded-2xl bg-[#211E1A] text-[#FBF9F4] shadow-[0_18px_40px_-16px_rgba(33,30,26,0.6)] px-4 py-3 flex items-start gap-3">
        <i class="pi pi-sparkles text-[13px] mt-0.5 text-[#E5C9A8]" aria-hidden="true"></i>
        <p class="flex-1 text-[13px] leading-snug">{{ aiLimitNotice }}</p>
        <button type="button" class="w-6 h-6 shrink-0 rounded-full hover:bg-white/10 flex items-center justify-center" :aria-label="t('common.actions.close')" @click="hideAiLimitNotice"><i class="pi pi-times text-[10px]"></i></button>
    </div>
</template>
